
import React, { useEffect, useState } from "react";
import { Dropdown } from 'primereact/dropdown';

export default function  SelectDropdown({key, sx={},inputName="", placeholder="",options=[],optionLabel,value,optionValue,handleFilter,clear,setClear,readOnly,disabled} ) {
    const [selected, setSelected] = useState(value||null);

    

    //  console.log("options",options);
    //  console.log("optionLabel",optionLabel);
    //  console.log("optionValue",optionValue);
    const selectedCountryTemplate = (option, props) => {
        // console.log('option',option);
        // console.log('props',props);
        if (option) {
            return (
                <div className="flex align-items-center">
                    {option.icon?(<img alt={option.name} src={option.icon?option.icon:"https://primefaces.org/cdn/primereact/images/flag/flag_placeholder.png"}  className={`mr-2 flag flag-${option.code.toLowerCase()}`} style={{ width: '18px' }} />):""}
                    <div>{optionLabel?option[optionLabel]:option.name}</div>
                </div>
            );
        }

        return <span>{props.placeholder}</span>;
    };

    const countryOptionTemplate = (option) => {    
        
        return (
            <div className="flex align-items-center">
                {option.icon?(<img alt={option.name} src={option.icon?option.icon:"https://primefaces.org/cdn/primereact/images/flag/flag_placeholder.png"}  className={`mr-2 flag flag-${option.code.toLowerCase()}`} style={{ width: '18px' }} />):""}
                <div>{optionLabel?option[optionLabel]:option.name}</div>
            </div>
        );
    };

    const handleSelect=(e)=>{
        // console.log("e.value",e.value);
        setSelected(e.value)
        handleFilter(inputName,e.value)  
        setClear && setClear(false)    
    }

    // console.log("value",value);
    

    return (
        <div key={key} className="card flex justify-content-center">
            <Dropdown  style={sx?sx:{}} 
                readOnly={readOnly}
                disabled={disabled}
                value={clear?null:selected}
                onChange={(e) =>handleSelect(e)} 
                options={options?options:[]} 
                optionLabel={optionLabel||'name'} 
                optionValue={optionValue||""}
                placeholder={placeholder} 
                filter 
                valueTemplate={selectedCountryTemplate} 
                itemTemplate={countryOptionTemplate} 
                className="w-full  md:w-10rem"                 
            />
        </div>    
    )
}
        